import PropTypes from 'prop-types';
import styles from './FJCreateVoiceCloning.module.less';
import FJUploadAudioToClone from './FJUploadAudioToClone.jsx';
import FJVoiceCloningSetting from './FJVoiceCloningSetting.jsx';
import FJVoiceCloningSuccess from './FJVoiceCloningSuccess.jsx';
import FJConstant from '../../../constants/FJConstant.js';

const FJCreateVoiceCloning = props => {
    const {
        createCloneStatus,
        uploadAudioInVoiceClone,
        profileId,
        voiceName,
        selectedLang,
        audioUrl,
        audioName,
        onChangeVoiceName,
        onChangeProfile,
        onChangeLang,
        onGenerate,
        goHistory,
        deleteAudio,
        openRecord,
        previewAudioUrl,

        taskStatus,
        isProjectLoading,
        creditNumber,
        onBack,
        hasHistoryList,
        freeNumCreationOfVoiceClone,
        isUploading,
        isInModal,
    } = props;
    return (
        <div className={styles.box}>
            <div className={styles.content}>
                {createCloneStatus === FJConstant.DEFAULT && (
                    <FJUploadAudioToClone
                        uploadAudioInVoiceClone={uploadAudioInVoiceClone}
                        openRecord={openRecord}
                        onBack={onBack}
                        hasHistoryList={hasHistoryList}
                        isUploading={isUploading}
                        isInModal={isInModal}
                    />
                )}
                {createCloneStatus === FJConstant.SETTING && (
                    <FJVoiceCloningSetting
                        profileId={profileId}
                        voiceName={voiceName}
                        selectedLang={selectedLang}
                        audioUrl={audioUrl}
                        onChangeVoiceName={onChangeVoiceName}
                        onChangeProfile={onChangeProfile}
                        onChangeLang={onChangeLang}
                        onGenerate={onGenerate}
                        audioName={audioName}
                        deleteAudio={deleteAudio}
                        taskStatus={taskStatus}
                        isProjectLoading={isProjectLoading}
                        creditNumber={creditNumber}
                        freeNumCreation={freeNumCreationOfVoiceClone}
                    />
                )}
                {createCloneStatus === FJConstant.SUCCESS && (
                    <FJVoiceCloningSuccess goHistory={goHistory} audioUrl={previewAudioUrl} />
                )}
            </div>
        </div>
    );
};

FJCreateVoiceCloning.propTypes = {
    createCloneStatus: PropTypes.string,
    uploadAudioInVoiceClone: PropTypes.func,
    profileId: PropTypes.string,
    voiceName: PropTypes.string,
    selectedLang: PropTypes.string,
    audioUrl: PropTypes.string,
    audioName: PropTypes.string,
    onChangeVoiceName: PropTypes.func,
    onChangeProfile: PropTypes.func,
    onChangeLang: PropTypes.func,
    onGenerate: PropTypes.func,
    goHistory: PropTypes.func,
    deleteAudio: PropTypes.func,
    openRecord: PropTypes.func,
    previewAudioUrl: PropTypes.string,
    taskStatus: PropTypes.string,
    isProjectLoading: PropTypes.bool,
    creditNumber: PropTypes.number,
    onBack: PropTypes.func,
    hasHistoryList: PropTypes.bool,
    freeNumCreationOfVoiceClone: PropTypes.number,
    isUploading: PropTypes.bool,
    isInModal: PropTypes.bool,
};
export default FJCreateVoiceCloning;
